import { router } from 'expo-router';
import { SquareCodeIcon } from 'lucide-react-native';

import { IconButton } from '../components/buttons/Button';

export const OpenDevDashboardButton = ({ hidden }: { hidden: boolean }) => {
    if (hidden) {
        return null;
    }

    return (
        <IconButton
            variant="tertiary"
            icon={SquareCodeIcon}
            onPress={() => {
                router.navigate('/dev');
            }}
        />
    );
};
